import React from "react";

export function FeedCaption(props) {
  const { caption, type } = props;

  if (!caption) {
    return null;
  }

  if (type === "adp") {
    return (
      <>
        From the community manager: <br /> {caption}
      </>
    );
  }

  return <>{caption}</>;
}

export default FeedCaption;
